export enum TipoReceitaEnum {

  COBRANCA,
  DAS,
  GUIA,
  SENDA,
  SIAFI
}
